/**
 * linkelhető tábla-sor
 */
$(document).ready(function($) {
    $(".tr-link").click(function() {
        window.document.location = $(this).data("href");
    });
});
